import { createNetworkApi } from '@lib/util/networkRequest';
import { formatOrder } from '@/util/formatters';

import apiInstance from '../instances/drupal';

export default createNetworkApi (apiInstance, {
  checkout: (productId, token) => ({
    method: 'post',
    url: '/iog-order',
    headers: {
      'X-CSRF-Token': token
    },
    data: {
      items: [
        {
          item_id: productId
        }
      ],
      success_url: `${process.env.NEXT_PUBLIC_BASE_URL}/developer/spend-tokens?stripe_success`,
      fail_url: `${process.env.NEXT_PUBLIC_BASE_URL}/developer/purchase-tokens?stripe_error`
    }
  }),

  spendTokens: (uid, gameId, tokensToSpend, token) => ({
    method: 'post',
    url: `/entity/game_spend_token?_format=json`,
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': token
    },
    data: {
      field_tokens_to_spend: [{ value: tokensToSpend }],
      field_game_name: [{ target_id: gameId }],
      user_id: [{ target_id: uid }]
    }
  }),

  getTokenBalance: (uid, token) => ({
    method: 'get',
    url: `/jsonapi/user/user?fields[user--user]=field_tokens&filter[uid]=${uid}`,
    headers: {
      'X-CSRF-Token': token
    },
    transform: (data) => ({ amount: data.data[0].attributes.field_tokens })
  }),

  getHistory: (uid, token) => ({
    method: 'get',
    url: `/jsonapi/commerce_order/default?filter[uid.uid]=${uid}&filter[state][operator]=<>&filter[state][value]=draft`,
    headers: {
      'X-CSRF-Token': token
    },
    transform: (result) => result.data.map((data) => formatOrder(data))
  })
});
